import Big from 'big.js';
import { PricingMode } from '../types';
import type { Security } from '../types/Security';
import { isInvertedOption, isLinearOption, toBigWithDefault } from '../utils';
import { useHomeCurrencyRateValue } from './useHomeCurrencyRate';

export function useEstimatedTotalPremium({
  security,
  pricingMode,
  underlyingPrice,
  quantity,
  quantityCurrency,
  price,
}: {
  security?: Security;
  pricingMode: PricingMode | undefined;
  underlyingPrice: string | undefined;
  quantity: string | undefined;
  quantityCurrency: string | undefined;
  price?: string;
}): Big {
  const quantityBig = toBigWithDefault(quantity, 0);
  const isInverted = isInvertedOption(security);
  const isLinear = isLinearOption(security);
  const underlyingPriceBig = toBigWithDefault(underlyingPrice, 0);
  const priceBig = toBigWithDefault(price, 0);

  let valueBig: Big = Big(0);
  const rateCurrency = security?.UnderlyingQuoteCurrency || 'USD';

  switch (pricingMode) {
    case PricingMode.UnderlyingQuoteCurrency:
      valueBig = quantityBig.times(priceBig);
      break;
    case PricingMode.ImpliedVolatility:
      break;
    default:
      if (isInverted) {
        valueBig = quantityBig.times(priceBig).times(underlyingPriceBig);
      } else if (isLinear) {
        valueBig = quantityBig.times(priceBig);
      }
  }

  if (!quantityCurrency) {
    // Contracts
    const notionalMultiplierBig = toBigWithDefault(security?.NotionalMultiplier, 1);
    valueBig = valueBig.times(notionalMultiplierBig);
  }

  const conversionRate = useHomeCurrencyRateValue(rateCurrency);
  const rate = toBigWithDefault(conversionRate?.Rate, 0);
  return valueBig.times(rate);
}
